import { IconDefinition } from "./types";

/**
 * @deprecated Use `squareCheck` instead. This icon will be removed in a future version.
 */
const squareTick: IconDefinition = {
  iconName: "square-tick",
  width: 448,
  height: 512,
  svgPathData:
    "M448 480l-448 0 0-448 448 0 0 448zM48 432l352 0 0-352-352 0 0 352zM347.7 178.8l-14.1 19.4-122.1 167.9-16.5 22.7-92.7-92.7 33.9-33.9 53 53 105.6-145.2 14.1-19.4 38.8 28.2z",
  iconType: "fill",
  fill: "none",
  unicode: 0xf14a,
};

export { squareTick };
